import { inject, Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class SeoService {
  private readonly meta = inject(Meta);
  private readonly title = inject(Title);

  updateSeo(seoData: any): void {
    this.updateTitle(seoData.metaTitle);
    this.updateTag('description', seoData.metaDescription);
    this.updateTag('keywords', seoData.keywords);
    this.updateTag('og:title', seoData.metaTitle);
    this.updateTag('og:description', seoData.metaDescription);
    this.updateTag('twitter:card', seoData.twitterCard || 'summary');
    this.updateTag('og:image', seoData.ogImage);

    if (seoData.canonicalUrl) {
      this.setCanonicalUrl(seoData.canonicalUrl);
    }
  }

  private updateTitle(title?: string): void {
    if (title) {
      this.title.setTitle(title);
    }
  }

  private updateTag(name: string, content?: string): void {
    if (content) {
      this.meta.updateTag({ name, content });
    } else {
      this.meta.removeTag(`name='${name}'`);
    }
  }

  private setCanonicalUrl(url: string): void {
    let link: HTMLLinkElement | null = document.querySelector("link[rel='canonical']");

    if (link) {
      link.href = url;
    } else {
      link = document.createElement('link');

      link.setAttribute('rel', 'canonical');
      link.setAttribute('href', url);

      document.head.appendChild(link);
    }
  }
}
